export default "__VITE_ASSET__11c7d998__"